import { render, staticRenderFns } from "./RetailerOrders.vue?vue&type=template&id=dbdc80b4&lang=pug"
import script from "./RetailerOrders.vue?vue&type=script&lang=js"
export * from "./RetailerOrders.vue?vue&type=script&lang=js"
import style0 from "./RetailerOrders.vue?vue&type=style&index=0&id=dbdc80b4&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports